/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/report-components/~/lodash-es/_freeGlobal.js
// module id = 186
// module chunks = 4